<template>
  <UiBtn
    v-tooltip="tooltipData"
    icon="common/info-circle"
    :active="statusTooltip"
    size="xs"
    color="gray"
    v-bind="dataGtmId ? { dataGtmId } : {}"
  />
</template>
<script>
export default {
  name: 'BaseInfoBtn',
  props: {
    text: { type: String, required: true },
    width: { type: String, default: '220' },
    position: { type: Object, default: () => ({ top: true, right: true }) },
    dataGtmId: { type: String },
  },
  data() {
    return {
      statusTooltip: false,
    }
  },
  computed: {
    tooltipData() {
      return {
        text: this.text,
        width: this.width,
        ...this.position,
        eventStatus: (status) => this.statusTooltip = status,
      }
    },
  },
}
</script>
